import { usePrimaryPage } from '@/PageManager'
import { unwrappedFeedAtom, switchFeed } from '@/atoms/feed'
import { hideFollowingAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { UserGroupIcon } from '@hugeicons/core-free-icons'
import BottomNavigationBarItem from './BottomNavigationBarItem'
import { useCurrentPubkey } from '@/atoms/session'
import { useAtomValue } from 'jotai'
import { unwrappedFollowListAtom } from '@/atoms/lists'

export default function FollowingButton() {
  const { navigate, current, display } = usePrimaryPage()
  const feed = useAtomValue(unwrappedFeedAtom)
  const pubkey = useCurrentPubkey()
  const followList = useAtomValue(unwrappedFollowListAtom)
  const hideFollowing = useAtomValue(hideFollowingAtom)

  if (hideFollowing || !pubkey || !followList || followList.length === 0) return null

  return (
    <BottomNavigationBarItem
      onClick={() => {
        navigate('home')
        switchFeed({ pubkey: pubkey })
      }}
      active={display && current === 'home' && feed && 'pubkey' in feed}
    >
      <HugeiconsIcon icon={UserGroupIcon} />
    </BottomNavigationBarItem>
  )
}
